<template>
  <div>
    <div class="page-header page-header-small">
      <parallax class="page-header-image" :style="backgroundTopo"></parallax>
      <div class="content-center">
        <div class="content-center brand">
          <h2 class="h1-seo">Criar demanda</h2>
        </div>
      </div>
    </div>

    <div class="section section-contact-us text-center">
      <div class="container">
        <form @submit.prevent="onSubmit" class="col-md-8 ml-auto mr-auto text-center">
          <p class="description">Informe abaixo os dados da demanda.</p>

          <div>
            <b-alert :show="showPagamento" variant="warning">
              <font-awesome-icon icon="circle-exclamation" class="mr-2" />
              <b>Atenção!</b>
              <br />Este tipo de demanda pode gerar um valor adicional para análise.
              <span v-if="linkValoresUrl">
                <br />Consulte os valores no site
                <a :href="linkValoresUrl" target="_blank" rel="noopener noreferrer" class="alert-link">
                  {{ empresa_texto_valores }}
                </a>
              </span>
            </b-alert>

            <b-alert :show="showDescricao" variant="info" class="text-left">
              <font-awesome-icon icon="info-circle" class="mr-2" />
              <span style="white-space: pre-line">{{ descricaoMensagem }}</span>
            </b-alert>
          </div>

          <b-card>
            <b-row>
              <b-col cols="6" v-if="!hasHiddenField('objetivo')">
                <b-form-group>
                  <b-form-select
                    :state="validateState('objetivo')"
                    class="form-control custom-select-green"
                    id="objetivo"
                    name="objetivo"
                    v-model="objetivo"
                    v-validate="'required'"
                    aria-describedby="objetivo-feedback"
                    @change="handleChangeObjetivo()"
                  >
                    <option :value="null">{{ labelSelecionarObjetivo }}</option>
                    <option v-for="(objetivo, idx) in getObjetivosByGrupo()" :key="idx" :value="objetivo.value.id">
                      {{ objetivo.text }}
                    </option>
                  </b-form-select>

                  <b-form-invalid-feedback id="objetivo-feedback">{{ labelInformarObjetivo }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col cols="6" v-if="!hasHiddenField('tipo')">
                <b-form-group>
                  <div class="d-flex align-items-center">
                    <b-form-select
                      :options="getTipos()"
                      :state="validateState('tipo')"
                      class="form-control custom-select-green"
                      id="tipo"
                      name="tipo"
                      v-model="tipo"
                      v-validate="'required'"
                      aria-describedby="tipo-feedback"
                      @change="getTiposArquivos()"
                      style="flex: 1"
                    ></b-form-select>
                    <b-input-group-append>
                      <b-button
                        v-if="tipo !== null && tipo.idAnexo !== undefined && tipo.idAnexo !== null"
                        class="ml-1"
                        variant="secondary"
                        @click="getDownloadAnexoTipo()"
                        style="width: 38px; height: 38px;"
                      >
                        <font-awesome-icon icon="circle-question" />
                      </b-button>
                    </b-input-group-append>
                  </div>
                  <b-form-invalid-feedback id="tipo-feedback">Selecione o 'Tipo' da demanda.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col cols="6" v-if="!hasHiddenField('area')">
                <b-form-group>
                  <b-form-select
                    :options="areas"
                    :state="validateState('area')"
                    class="form-control custom-select-green"
                    id="area"
                    name="area"
                    v-model="area"
                    v-validate="'required'"
                    aria-describedby="area-feedback"
                  ></b-form-select>
                  <b-form-invalid-feedback id="area-feedback">Selecione a 'Área' da demanda.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" v-if="!hasHiddenField('titulo')">
                <b-form-group>
                  <b-form-input
                    :state="validateState('titulo')"
                    id="titulo"
                    name="titulo"
                    placeholder="Título/descrição"
                    v-model="titulo"
                    v-validate="'required'"
                    aria-describedby="titulo-feedback"
                    maxlength="50"
                    autofocus
                  ></b-form-input>

                  <b-form-invalid-feedback id="titulo-feedback"
                    >É necessário informar o campo 'Título'.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>

              <b-col cols="12" v-if="!hasHiddenField('cidade')">
                <b-form-group>
                  <b-form-select
                    :state="validateState('cidade')"
                    class="form-control custom-select-green"
                    id="cidade"
                    name="cidade"
                    v-model="cidade"
                    v-validate="'required'"
                    aria-describedby="cidade-feedback"
                    @change="handleSelectCidade"
                  >
                    <option :value="null">Selecione a Cidade</option>
                    <optgroup
                      v-if="trecho == null"
                      v-for="(rdv, idxRdv) in getRodoviasByTrechos()"
                      :key="idxRdv"
                      :label="rdv"
                    >
                      <option v-for="(cidade, idx) in getCidadesByRodovia(rdv)" :key="idx" :value="cidade.value">
                        {{ cidade.text }}
                      </option>
                    </optgroup>
                    <option
                      v-if="trecho != null"
                      v-for="(cidade, idx) in getCidades()"
                      :key="idx"
                      :value="cidade.value"
                    >
                      {{ cidade.text }}
                    </option>
                  </b-form-select>
                  <b-form-invalid-feedback id="cidade-feedback">Informe a 'Cidade' da demanda.</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col cols="8" v-if="!hasHiddenField('rodovia')">
                <b-form-group>
                  <b-form-select
                    :state="validateState('trecho')"
                    class="form-control custom-select-green"
                    id="trecho"
                    name="trecho"
                    v-model="trecho"
                    v-validate="'required'"
                    aria-describedby="trecho-feedback"
                  >
                    <option :value="null">Selecione a Rodovia</option>
                    <optgroup v-for="(rodovia, idx) in getRodoviasByTrechos()" :key="idx" :label="rodovia">
                      <option v-for="(trecho, idxTre) in getTrechosByRodovia(rodovia)" :key="idxTre" :value="trecho.id">
                        {{ getTrechoInfo(trecho) }}
                      </option>
                    </optgroup>
                  </b-form-select>
                  <b-form-invalid-feedback id="trecho-feedback"
                    >Informe a 'Rodovia' da demanda.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>

              <b-col cols="4" v-if="!hasHiddenField('sentido')">
                <b-form-group>
                  <b-form-select
                    class="form-control custom-select-green"
                    id="sentido"
                    name="sentido"
                    v-model="sentido"
                    aria-describedby="sentido-feedback"
                  >
                    <option :value="null">Selecione o Sentido</option>
                    <option v-for="(opt, idxSent) in fieldSentido" :key="idxSent" :value="opt.value">
                      {{ opt.text }}
                    </option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col
                cols="3"
                v-if="trecho == undefined && !hasHiddenField('kmInicial') && sentido !== null && sentido !== undefined"
              >
                <b-form-group>
                  <vue-numeric
                    class="direita form-control"
                    :precision="3"
                    :state="errorKmInicial == null"
                    id="kmInicial"
                    name="kmInicial"
                    placeholder="KM Inicial"
                    separator="."
                    thousand-separator="."
                    decimal-separator=","
                    v-model="kmInicial"
                    @change="changeKmInicial"
                    aria-describedby="kmIni-feedback"
                  ></vue-numeric>

                  <b-form-invalid-feedback :state="errorKmInicial == null" id="kmIni-feedback">{{
                    errorKmInicial
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col
                cols="3"
                v-if="trecho != undefined && !hasHiddenField('kmInicial') && sentido !== null && sentido !== undefined"
              >
                <b-input-group>
                  <vue-numeric
                    class="direita form-control"
                    :precision="3"
                    :state="errorKmInicial == null"
                    id="kmInicial"
                    name="kmInicial"
                    placeholder="KM Inicial"
                    separator="."
                    thousand-separator="."
                    decimal-separator=","
                    v-model="kmInicial"
                    @change="changeKmInicial"
                    aria-describedby="kmIni-feedback"
                  ></vue-numeric>

                  <b-input-group-append>
                    <b-button variant="primary" @click="openMapForChooseKm('I')">
                      <i v-if="!loadingCoordRodKmInicial" class="now-ui-icons location_pin" />
                      <b-spinner v-else style="width: 0.8rem; height: 0.8rem;"></b-spinner>
                    </b-button>
                  </b-input-group-append>

                  <b-form-invalid-feedback :state="errorKmInicial == null" id="kmIni-feedback">{{
                    errorKmInicial
                  }}</b-form-invalid-feedback>
                </b-input-group>
              </b-col>

              <b-col
                cols="3"
                v-if="trecho == undefined && !hasHiddenField('kmFinal') && sentido !== null && sentido !== undefined"
              >
                <b-form-group>
                  <vue-numeric
                    class="direita form-control"
                    :precision="3"
                    :state="errorKmFinal == null"
                    id="kmFinal"
                    name="kmFinal"
                    placeholder="KM Final"
                    separator="."
                    thousand-separator="."
                    decimal-separator=","
                    v-model="kmFinal"
                    @change="changeKmFinal"
                    aria-describedby="kmFim-feedback"
                  ></vue-numeric>

                  <b-form-invalid-feedback :state="errorKmFinal == null" id="kmFim-feedback">{{
                    errorKmFinal
                  }}</b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col
                cols="3"
                v-if="trecho != undefined && !hasHiddenField('kmFinal') && sentido !== null && sentido !== undefined"
              >
                <b-input-group>
                  <vue-numeric
                    class="direita form-control"
                    :precision="3"
                    :state="errorKmFinal == null"
                    id="kmFinal"
                    name="kmFinal"
                    placeholder="KM Final"
                    separator="."
                    thousand-separator="."
                    decimal-separator=","
                    v-model="kmFinal"
                    @change="changeKmFinal"
                    aria-describedby="kmFim-feedback"
                  ></vue-numeric>

                  <b-input-group-append>
                    <b-button variant="primary" @click="openMapForChooseKm('F')">
                      <i v-if="!loadingCoordRodKmFinal" class="now-ui-icons location_pin" />
                      <b-spinner v-else style="width: 0.8rem; height: 0.8rem;"></b-spinner>
                    </b-button>
                  </b-input-group-append>

                  <b-form-invalid-feedback :state="errorKmFinal == null" id="kmFim-feedback">{{
                    errorKmFinal
                  }}</b-form-invalid-feedback>
                </b-input-group>
              </b-col>

              <b-col cols="6" v-if="!hasHiddenField('local')">
                <b-form-group>
                  <b-form-select
                    :options="locais"
                    class="form-control"
                    id="local"
                    name="local"
                    v-model="local"
                    aria-describedby="local-feedback"
                  ></b-form-select>
                </b-form-group>
              </b-col>

              <b-col cols="6" v-if="!hasHiddenField('nomenclaturaAlca')">
                <b-form-group>
                  <b-form-select
                    :options="alcas"
                    :state="validateState('alcas')"
                    class="form-control"
                    id="alca"
                    name="alca"
                    v-model="alca"
                    aria-describedby="alca-feedback"
                  ></b-form-select>
                </b-form-group>
              </b-col>

              <b-col cols="6" v-if="!hasHiddenField('faixa')">
                <b-form-group>
                  <b-form-select
                    :options="faixas"
                    :state="validateState('faixa')"
                    class="form-control"
                    id="faixa"
                    name="faixa"
                    v-model="faixa"
                    aria-describedby="faixa-feedback"
                  ></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" v-if="!hasHiddenField('observacao')">
                <b-form-group>
                  <b-form-textarea
                    :state="validateState('observacao')"
                    class="form-control"
                    id="observacao"
                    name="observacao"
                    rows="2"
                    cols="80"
                    placeholder="Observações..."
                    v-model="observacao"
                    v-validate="'required'"
                    aria-describedby="observacao-feedback"
                    maxlength="255"
                  ></b-form-textarea>
                  <b-form-invalid-feedback id="observacao-feedback"
                    >É necessário informar as observações.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col v-if="modelosObjetivo.length > 0" cols="12">
                <div class="text-left mb-3">
                  <b>Modelos de documentação para download:</b>
                  <ul class="mb-0">
                    <li v-for="(modelo, idxModelo) in modelosObjetivo" :key="idxModelo">
                      <a href="#" @click.prevent="downloadModelo(modelo)">
                        {{ modelo.descricao || modelo.nome }}
                      </a>
                    </li>
                  </ul>
                </div>
              </b-col>
              <b-col v-if="tipo != null" cols="12">
                <b-table
                  :show-empty="true"
                  :fields="fieldsAnexos"
                  :items="anexos"
                  empty-text="Não há dados disponíveis."
                >
                  <template #cell(nomeArquivo)="row">
                    <div v-if="row.item.obrigatorio == 1" class="font-weight-bold">
                      {{ row.item.nomeArquivo }}
                    </div>
                    <div v-else>
                      {{ row.item.nomeArquivo }}
                    </div>
                  </template>

                  <template #cell(tipoArquivo)="row">
                    {{ getTipoArquivo(row.item) }}
                  </template>

                  <template #cell(arquivo)="row">
                    <div class="d-flex flex-column align-items-center w-100">
                      <div class="d-flex align-items-center anexo-centralizado w-100 justify-content-center">
                        <span v-if="row.item.uploadedFile" class="arquivo-borda nome-arquivo-centralizado">
                          {{ row.item.uploadedFile.name }}
                        </span>
                        <b-button
                          v-if="row.item.uploadedFile"
                          variant="danger"
                          size="sm"
                          class="ml-2"
                          @click="removeAnexo(row.item)"
                          title="Remover arquivo"
                          style="line-height:1; padding: 0 4px; height: 22px; min-width: 22px; border-width: 1.5px;"
                        >
                          <i class="fa fa-trash" style="font-size: 0.85em;"></i>
                        </b-button>
                        <b-form-file
                          v-else
                          v-model="row.item.uploadedFile"
                          placeholder="Selecione o arquivo"
                          browse-text="Escolher"
                          :state="validateStateAnexo(row.item.id.sequencia)"
                          :id="'arquivo-' + row.item.id.sequencia"
                          :name="'arquivo-' + row.item.id.sequencia"
                          :ref="'fileInput-' + row.item.id.sequencia"
                          :aria-describedby="'arquivo-feedback-' + row.item.id.sequencia"
                          :accept="getTypeFile(row.item.tipoArquivo)"
                          @input="onUploadAnexos($event, row.item.id.sequencia)"
                          class="w-100"
                        />
                      </div>
                      <b-form-invalid-feedback
                        :id="'arquivo-feedback-' + row.item.id.sequencia"
                        v-if="anexosInvalidos.includes(row.item.id.sequencia)"
                        class="d-block text-center mt-1"
                      >
                        Este arquivo é obrigatório.
                      </b-form-invalid-feedback>
                    </div>
                  </template>
                </b-table>
              </b-col>
            </b-row>

            <!-- Campos do Requerente -->
            <b-row v-if="!hasHiddenField('requerente')">
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox v-model="abrirEmNomeOutraParte" name="abrirEmNomeOutraParte">
                    Estou abrindo esta demanda em nome de outra parte
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row v-if="abrirEmNomeOutraParte">
              <b-col cols="6">
                <b-form-group>
                  <b-form-select
                    :state="validateState('tipoRequerente')"
                    class="form-control custom-select-green"
                    id="tipoRequerente"
                    name="tipoRequerente"
                    v-model="tipoRequerente"
                    v-validate="abrirEmNomeOutraParte ? 'required' : ''"
                    aria-describedby="tipoRequerente-feedback"
                  >
                    <option :value="null">Selecione o tipo</option>
                    <option value="PF">Pessoa Física</option>
                    <option value="PJ">Pessoa Jurídica</option>
                  </b-form-select>
                  <b-form-invalid-feedback id="tipoRequerente-feedback"
                    >Selecione o tipo de requerente.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="6" v-if="tipoRequerente">
                <b-form-group>
                  <b-form-input
                    :state="validateState('nomeRequerente')"
                    id="nomeRequerente"
                    name="nomeRequerente"
                    :placeholder="tipoRequerente === 'PF' ? 'Nome completo' : 'Razão Social'"
                    v-model="nomeRequerente"
                    v-validate="tipoRequerente ? 'required' : ''"
                    aria-describedby="nomeRequerente-feedback"
                    maxlength="255"
                  ></b-form-input>
                  <b-form-invalid-feedback id="nomeRequerente-feedback"
                    >Informe o {{ tipoRequerente === 'PF' ? 'nome completo' : 'razão social' }} do requerente.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="6" v-if="tipoRequerente === 'PF'">
                <b-form-group>
                  <b-form-input
                    :state="validateState('cpfRequerente')"
                    id="cpfRequerente"
                    name="cpfRequerente"
                    placeholder="CPF (000.000.000-00)"
                    v-model="cpfRequerente"
                    v-validate="tipoRequerente === 'PF' ? 'required' : ''"
                    @input="formatarCPF($event)"
                    aria-describedby="cpfRequerente-feedback"
                    maxlength="14"
                  ></b-form-input>
                  <b-form-invalid-feedback id="cpfRequerente-feedback"
                    >Informe o CPF do requerente.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
              <b-col cols="6" v-if="tipoRequerente === 'PJ'">
                <b-form-group>
                  <b-form-input
                    :state="validateState('cnpjRequerente')"
                    id="cnpjRequerente"
                    name="cnpjRequerente"
                    placeholder="CNPJ (00.000.000/0000-00)"
                    v-model="cnpjRequerente"
                    v-validate="tipoRequerente === 'PJ' ? 'required' : ''"
                    @input="formatarCNPJ($event)"
                    aria-describedby="cnpjRequerente-feedback"
                    maxlength="18"
                  ></b-form-input>
                  <b-form-invalid-feedback id="cnpjRequerente-feedback"
                    >Informe o CNPJ do requerente.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="showPagamento">
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    id="aceitePagamento"
                    name="aceitePagamento"
                    v-model="aceitePagamento"
                    v-validate="showPagamento ? 'required' : ''"
                    aria-describedby="aceitePagamento-feedback"
                  >
                    Declaro estar ciente sobre a possibilidade de cobrança para análise desta demanda pela Concessionária EPR Litoral Pioneiro, conforme valores especificados no site.
                  </b-form-checkbox>
                  <b-form-invalid-feedback id="aceitePagamento-feedback" class="d-block"
                    >É necessário aceitar a declaração de ciência sobre a possibilidade de cobrança.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>
            </b-row>
          </b-card>
          <b-row>
            <b-col :cols="2"></b-col>
            <b-col cols="8">
              <div class="send-button">
                <b-button
                  :disabled="(veeErrors.any() && !busySave) || busySave"
                  class="btn-round"
                  type="submit"
                  variant="primary"
                  block
                  size="lg"
                >
                  <span v-if="!busySave">Enviar solicitação</span>
                  <b-spinner v-else small />
                </b-button>
              </div>
            </b-col>
          </b-row>

          <b-modal id="confirm-modal" hide-footer>
            <template slot="modal-title">
              Solicitação incluída
            </template>
            <div class="d-block text-center">
              <div class="mx-3">
                <b-alert :show="showPagamento" variant="warning">
                  <i class="fa-solid fa-circle-exclamation"></i> Este tipo de demanda pode gerar um valor adicional para
                  análise.
                </b-alert>
                <div v-if="showPagamento && linkValoresUrl" class="mx-2">
                  <a :href="linkValoresUrl" target="_blank" rel="noopener noreferrer">Veja o valor a ser pago</a>
                </div>
              </div>

              Sua solicitação foi realizada com sucesso.
              <br />
              <span>N&deg; Protocolo: {{ protocolo }}</span>
            </div>
            <b-button class="mt-2" block variant="primary" @click="gerarReciboPDF" v-if="protocolo">
              <i class="fa fa-file-pdf mr-2"></i> Gerar Recibo em PDF
            </b-button>
            <b-button class="mt-2" block @click="hideModal">Fechar</b-button>
          </b-modal>

          <b-modal id="error-modal" hide-footer>
            <template slot="modal-title"
              >Erro incluindo Solicitação</template
            >
            <div class="d-block text-center">Não foi possível registrar sua solicitação.</div>
            <b-button class="mt-2" block @click="hideModalError">Fechar</b-button>
          </b-modal>

          <b-modal
            id="modalChooseKm"
            size="xl"
            :title="chooseKm == 'I' ? 'Escolha do km inicial' : 'Escolha do km final'"
            hide-footer
          >
            <!-- Alerta para quando não há KMZ/coordenadas -->
            <b-alert
              :show="showCoordenadasAlert"
              variant="warning"
              @dismissed="showCoordenadasAlert = false"
              class="mb-3"
            >
              <font-awesome-icon icon="circle-exclamation" class="mr-2" />
              <b>Atenção!</b>
              <br />Não foi possível carregar o arquivo KMZ para esta cidade da rodovia
            </b-alert>

            <gmaps-map :options="mapOptions" :style="mapStyle" :zoom="10">
              <!-- Quando sentido escolhido tiver crescente e decrescente, ou seja, ambos, mostrar duas linhas no mapa -->
              <template v-if="sentido === 'A' || sentido === 'AMBOS'">
                <!-- Linha crescente (azul) -->
                <gmaps-polyline
                  v-if="coordenadasCrescente.length > 0"
                  :path="coordenadasCrescente"
                  strokeColor="blue"
                  strokeWeight="8"
                  strokeOpacity="0.6"
                  @click="ChooseKmMap"
                />
                <!-- Linha decrescente (vermelho) -->
                <gmaps-polyline
                  v-if="coordenadasDecrescente.length > 0"
                  :path="coordenadasDecrescente"
                  strokeColor="red"
                  strokeWeight="8"
                  strokeOpacity="0.6"
                  @click="ChooseKmMap"
                />
              </template>

              <!-- Quando sentido for crescente -->
              <gmaps-polyline
                v-else-if="sentido === 'C' && coordenadasCrescente.length > 0"
                :path="coordenadasCrescente"
                strokeColor="blue"
                strokeWeight="15"
                strokeOpacity="0.8"
                @click="ChooseKmMap"
              />

              <!-- Quando sentido for decrescente -->
              <gmaps-polyline
                v-else-if="sentido === 'D' && coordenadasDecrescente.length > 0"
                :path="coordenadasDecrescente"
                strokeColor="red"
                strokeWeight="15"
                strokeOpacity="0.8"
                @click="ChooseKmMap"
              />

              <gmaps-polyline
                v-else-if="coordenadasRodovia.length > 0"
                :path="coordenadasRodovia"
                strokeColor="green"
                strokeWeight="15"
                strokeOpacity="0.8"
                @click="ChooseKmMap"
              />
            </gmaps-map>
          </b-modal>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VueNumeric from 'vue-numeric';
import { Badge, Button, FormGroupInput } from '@/components';
import { mapState } from 'vuex';
import { gmapsMap, gmapsPolyline } from 'x5-gmaps';

import moment from 'moment';

import numeral from 'numeral';
import 'numeral/locales';

export default {
  name: 'novaDemanda',
  bodyClass: 'novaDemanda-page',
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
    [Badge.name]: Badge,
    VueNumeric,
    gmapsMap,
    gmapsPolyline
  },
  data() {
    return {
      backgroundTopo: "background-image: url('/img/solicitacao.jpg')",
      tipos: [{ value: null, text: 'Selecione o Tipo' }],
      areas: [{ value: null, text: 'Selecione a Área' }],
      objetivos: [{ value: null, text: this.labelSelecionarObjetivo }],
      locais: [{ value: null, text: 'Selecione o Local' }],
      alcas: [{ value: null, text: 'Nomenclatura da Alça' }],
      faixas: [{ value: null, text: 'Selecione a Faixa' }],
      cidades: [], // Array of cidades
      trechos: [], // Array of trechos
      hiddenFields: Vue.prototype.$externalConfig.HIDDEN_FIELDS,
      fieldSentido: Vue.prototype.$externalConfig.FIELD_SENTIDO,
      titulo: '',
      tipo: null,
      area: null,
      objetivo: null,
      cidade: null,
      trecho: null,
      trechoCidade: null, // helper para filtrar trechos x cidade
      kmInicial: '',
      kmFinal: '',
      sentido: null,
      local: null,
      alca: null,
      faixa: 'FAIXA_1',
      observacao: '',
      files: [],
      protocolo: '',
      demandaIdCriada: null,
      tiposAnexo: [],
      labelSelecionarObjetivo: 'Selecione o Objetivo',
      labelInformarObjetivo: "Informe a 'Objetivo' da demanda.",
      labelSelecionarTipo: 'Selecione o Tipo',
      labelInformarTipo: "Informe o 'Tipo' da demanda",
      errorKmInicial: null,
      errorKmFinal: null,
      empresa_texto_valores: '',
      linkValoresUrl: null,
      mostrarTextoConsultaSemLink: false,

      busySave: false,
      showPagamento: false,
      showDescricao: false,
      descricaoMensagem: '',
      refCodeDemandas: {},
      abrirEmNomeOutraParte: false,
      tipoRequerente: null,
      nomeRequerente: '',
      cpfRequerente: '',
      cnpjRequerente: '',
      aceitePagamento: false,

      anexos: [],
      modelosObjetivo: [],
      fieldsAnexos: [
        { key: 'nomeArquivo', label: 'Nome/Descrição do arquivo' },
        { key: 'arquivo', label: 'Arquivo' },
        { key: 'tipoArquivo', label: 'Tipo' }
      ],
      anexosInvalidos: [],
      optionsArquivo: [
        {
          id: 1,
          descricao: 'Arquivo PDF'
        },
        {
          id: 2,
          descricao: 'Documento Texto (DOCX)'
        },
        {
          id: 3,
          descricao: 'Planilha Eletrônica (XLSX)'
        },
        {
          id: 4,
          descricao: 'Imagem (PNG/JPG/BMP)'
        },
        {
          id: 5,
          descricao: 'PowerPoint (PPT)'
        },
        {
          id: 6,
          descricao: 'E-mail (MSG/EML)'
        },
        {
          id: 7,
          descricao: 'Arquivo compactado (ZIP/RAR)'
        },
        {
          id: 8,
          descricao: 'Projeto CAD (DWG/DXF)'
        },
        {
          id: 9,
          descricao: 'Arquivo KMZ'
        }
      ],

      // Modal mapa
      chooseKm: undefined,
      mapOptions: {
        center: { lat: -23.550278, lng: -46.633889 },
        zoom: 10,
        zoomControl: true,
        mapTypeId: 'satellite',
        mapTypeControl: true,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false
      },
      mapStyle: 'width: 99%; height: 500px;',
      coordenadasRodovia: [],
      coordenadasCrescente: [],
      coordenadasDecrescente: [],
      rodovias: [],
      loadingCoordRodKmInicial: false,
      loadingCoordRodKmFinal: false,
      showCoordenadasAlert: false, // Novo campo para controlar o alerta no modal
      showSentidoUnicoAlert: false, // Alerta quando há apenas um sentido
      sentidoDisponivel: null // Sentido disponível quando há apenas um
    };
  },
  computed: {
    ...mapState('empresa', ['empresas', 'empresaAtual'])
  },
  watch: {
    // Zerar KMs quando sentido mudar
    sentido(newSentido, oldSentido) {
      if (newSentido !== oldSentido && oldSentido !== null && oldSentido !== undefined) {
        this.kmInicial = '';
        this.kmFinal = '';
        this.errorKmInicial = null;
        this.errorKmFinal = null;

        // Limpar coordenadas do mapa
        this.coordenadasRodovia = [];
        this.coordenadasCrescente = [];
        this.coordenadasDecrescente = [];
      }
    },

    // Resetar KMs quando cidade mudar
    cidade(newCidade, oldCidade) {
      if (newCidade !== oldCidade) {
        // Limpar KMs quando cidade muda
        this.kmInicial = '';
        this.kmFinal = '';
        this.errorKmInicial = null;
        this.errorKmFinal = null;

        // Limpar coordenadas do mapa
        this.coordenadasRodovia = [];
        this.coordenadasCrescente = [];
        this.coordenadasDecrescente = [];
      }
    }
  },
  mounted() {
    if (window.config) {
      if (window.config.LABELS) {
        this.labelSelecionarObjetivo = window.config.LABELS.novaDemanda.selecionarObjetivo;
        this.labelSelecionarTipo = window.config.LABELS.novaDemanda.selecionarTipo;
        this.labelInformarObjetivo = window.config.LABELS.novaDemanda.informarObjetivo;
        this.labelInformarTipo = window.config.LABELS.novaDemanda.informarTipo;
      }

      if (window.config.SIGLA_ASSETS) {
        const siglaAssets = window.config.SIGLA_ASSETS;
        this.backgroundTopo = `background-image: url('/img/${siglaAssets}/solicitacao.jpg')`;
      }

      if (window.config.EMPRESA_TEXTO_VALORES) {
        this.empresa_texto_valores = window.config.EMPRESA_TEXTO_VALORES;
      }

      const textoIsDefault = !this.empresa_texto_valores || this.empresa_texto_valores.toLowerCase() === 'default';
      const urlIsDefault = !window.config.EMPRESA_LINK_VALORES_URL || window.config.EMPRESA_LINK_VALORES_URL.toLowerCase() === 'default';

      if (!textoIsDefault && !urlIsDefault) {
        this.linkValoresUrl = window.config.EMPRESA_LINK_VALORES_URL;
      } else if (!textoIsDefault && urlIsDefault) {
        this.mostrarTextoConsultaSemLink = true;
      }
    }

    numeral.locale('pt-br');

    this.fillData();
  },
  methods: {
    normalizeKm(value) {
      if (value === null || value === undefined || value === '') return null;

      if (typeof value === 'number' && !isNaN(value) && isFinite(value)) {
        if (value < 10000) {
          return value;
        }
        if (value % 1 === 0 && value >= 10000) {
          const div1000 = value / 1000;
          if (div1000 < 10000 && div1000 >= 0) {
            return div1000;
          }
          const div100 = value / 100;
          if (div100 < 10000 && div100 >= 0) {
            return div100;
          }
          const div10 = value / 10;
          if (div10 < 10000 && div10 >= 0) {
            return div10;
          }
        }
        return value;
      }

      let strValue = String(value).trim();
      if (strValue === '') return null;
      
      let num;
      if (strValue.includes(',')) {
        strValue = strValue.replace(/\./g, '').replace(',', '.');
        num = parseFloat(strValue);
      }
      else if (strValue.includes('.')) {
        const parts = strValue.split('.');
        if (parts.length > 2) {
          strValue = strValue.replace(/\./g, '');
          num = parseFloat(strValue);
        }
        else {
          if (parts[1] && parts[1].length <= 3) {
            num = parseFloat(strValue);
          } else {
            num = parseFloat(strValue.replace(/\./g, ''));
          }
        }
      }
      else {
        num = parseFloat(strValue);
        if (num >= 10000 && num % 1 === 0) {
          const div1000 = num / 1000;
          if (div1000 < 10000 && div1000 >= 0) {
            num = div1000;
          }
          else {
            const div100 = num / 100;
            if (div100 < 10000 && div100 >= 0) {
              num = div100;
            }
            else {
              const div10 = num / 10;
              if (div10 < 10000 && div10 >= 0) {
                num = div10;
              }
            }
          }
        }
      }
      
      return isNaN(num) ? null : num;
    },
    changeKmInicial() {
      this.errorKmInicial = null;
      this.validateKmAgainstCity();
    },
    changeKmFinal() {
      this.errorKmFinal = null;
      this.validateKmAgainstCity();
    },
    validateKmAgainstCity() {
      if (!this.cidade) return;
      
      const cidadeData = this.cidades.find(c => c.id === this.cidade.id);
      if (!cidadeData) return;

      const kmInicialCidade = this.normalizeKm(cidadeData.kmInicial);
      const kmFinalCidade = this.normalizeKm(cidadeData.kmFinal);
      
      if (kmInicialCidade === null || kmFinalCidade === null) return;

      const isCrescente = kmInicialCidade <= kmFinalCidade;

      if (this.kmInicial !== null && this.kmInicial !== undefined && this.kmInicial !== '') {
        const kmInicialDemanda = this.normalizeKm(this.kmInicial);
        if (kmInicialDemanda !== null) {
          if (isCrescente) {
            if (kmInicialDemanda < kmInicialCidade) {
              this.errorKmInicial = `KM inicial deve ser maior ou igual a ${kmInicialCidade.toFixed(3)}`;
            } else {
              this.errorKmInicial = null;
            }
          } else {
            if (kmInicialDemanda > kmInicialCidade) {
              this.errorKmInicial = `KM inicial deve ser menor ou igual a ${kmInicialCidade.toFixed(3)}`;
            } else {
              this.errorKmInicial = null;
            }
          }
        }
      }

      if (this.kmFinal !== null && this.kmFinal !== undefined && this.kmFinal !== '') {
        const kmFinalDemanda = this.normalizeKm(this.kmFinal);
        if (kmFinalDemanda !== null) {
          if (isCrescente) {
            if (kmFinalDemanda > kmFinalCidade) {
              this.errorKmFinal = `KM final deve ser menor ou igual a ${kmFinalCidade.toFixed(3)}`;
            } else {
              this.errorKmFinal = null;
            }
          } else {
            if (kmFinalDemanda < kmFinalCidade) {
              this.errorKmFinal = `KM final deve ser maior ou igual a ${kmFinalCidade.toFixed(3)}`;
            } else {
              this.errorKmFinal = null;
            }
          }
        }
      }

      if (this.kmInicial !== null && this.kmInicial !== undefined && this.kmInicial !== '' &&
          this.kmFinal !== null && this.kmFinal !== undefined && this.kmFinal !== '') {
        
        const kmInicialDemanda = this.normalizeKm(this.kmInicial);
        const kmFinalDemanda = this.normalizeKm(this.kmFinal);

        if (kmInicialDemanda !== null && kmFinalDemanda !== null) {
          if (isCrescente && kmInicialDemanda > kmFinalDemanda) {
            this.errorKmInicial = 'KM inicial não pode ser maior que KM final';
            this.errorKmFinal = 'KM final não pode ser menor que KM inicial';
          } else if (!isCrescente && kmInicialDemanda < kmFinalDemanda) {
            this.errorKmInicial = 'KM inicial não pode ser menor que KM final';
            this.errorKmFinal = 'KM final não pode ser maior que KM inicial';
          }
        }
      }
    },
    fillData() {
      const sigla = this.$store.state.empresa.empresaAtual.sigla;
      const token = this.$store.state.account.user;
      const options = { headers: { Authorization: `Bearer ${token}` } };

      this.tipos = [{ value: null, text: this.labelSelecionarTipo }];
      this.areas = [{ value: null, text: 'Selecione a Área' }];
      this.objetivos = [{ value: null, text: 'Selecione o Objetivo' }];
      this.locais = [{ value: null, text: 'Selecione o Local' }];
      this.alcas = [{ value: null, text: 'Nomenclatura da Alça' }];
      this.faixas = [{ value: null, text: 'Selecione a Faixa' }];

      this.cidades = []; // Array of cidades
      this.trechos = []; // array of trechos

      // Fill Locais
      this.locais.push({ value: 'EIXO_TRONCAL', text: 'Eixo Troncal' });
      this.locais.push({ value: 'MARGINAL_DIREITA', text: 'Marginal Direita' });
      this.locais.push({ value: 'MARGINAL_ESQUERDA', text: 'Marginal Esquerda' });
      this.locais.push({ value: 'DISPOSITIVO', text: 'Dispositivo' });

      // Fill Faixas
      this.faixas.push({ value: 'FAIXA_1', text: '1' });
      this.faixas.push({ value: 'FAIXA_2', text: '2' });
      this.faixas.push({ value: 'FAIXA_3', text: '3' });
      this.faixas.push({ value: 'FAIXA_4', text: '4' });
      this.faixas.push({ value: 'FAIXA_5', text: '5' });
      this.faixas.push({ value: 'FAIXA_6', text: '6' });
      this.faixas.push({ value: 'ACOSTAMENTO_INTERNO', text: 'Acostamento Interno' });
      this.faixas.push({ value: 'ACOSTAMENTO_EXTERNO', text: 'Acostamento Externo' });

      // Fill Nomenclaturas : Ramos
      for (let i = 100; i <= 900; i += 100) {
        this.alcas.push({ value: 'RAMO_' + i, text: 'Ramo ' + i });
      }

      // Fill Nomenclaturas : Rotatórias
      for (let i = 100; i <= 900; i += 100) {
        this.alcas.push({ value: 'ROTATORIA_', text: 'Rotatória ' + i });
      }

      Vue.axios.get(`/faixasDominio/${sigla}/dados`, options).then(response => {
        const rowData = response.data;

        // Áreas
        if (rowData.areas) {
          for (var area of rowData.areas) {
            this.areas.push({ value: area.id, text: area.descricao });
          }
        }

        // Tipos
        if (rowData.tipos) {
          for (var tipo of rowData.tipos) {
            if (window.config.SIGLA_ASSETS === 'epr') {
              if (tipo.descricao.includes('[FASE I]')) {
                this.tipos.push({ value: tipo, text: tipo.descricao });
              } else if (tipo.descricao.includes('[FASE II]')) {
                this.tipos.push({ value: tipo, text: tipo.descricao, disabled: true });
              } else if (tipo.descricao.includes('[FASE III]')) {
                this.tipos.push({ value: tipo, text: tipo.descricao, disabled: true });
              } else {
                this.tipos.push({ value: tipo, text: tipo.descricao });
              }
            } else {
              this.tipos.push({ value: tipo, text: tipo.descricao });
            }
          }
        }

        // Tipos
        if (rowData.objetivos) {
          for (var obj of rowData.objetivos) {
            this.objetivos.push({ value: obj, text: obj.descricao });
          }
        }

        // Rodovias
        this.rodovias = rowData.rodovias;

        // Trechos
        this.trechos = rowData.trechos;

        // Cidades
        this.cidades = rowData.cidades;

        // Sentidos conforme o padrão configurado da empresa (Convencional x Cardeal),
        // retornado pela API. Fallback à configuração estática FIELD_SENTIDO quando a
        // API não devolver a lista (compatibilidade com versões anteriores do backend).
        if (rowData.sentidos && rowData.sentidos.length) {
          this.fieldSentido = rowData.sentidos.map(s => ({ value: s.code, text: s.descricao }));
        }
      });
    },
    getCidades() {
      const cidadesData = [];
      for (const cidade of this.cidades) {
        if (this.trecho != null && this.trecho !== undefined) {
          if (cidade.idTrecho != this.trecho) {
            continue;
          }
        }

        cidadesData.push({
          value: cidade,
          text: cidade.cidade.descricao + ' - [Km ' + cidade.kmInicial + ' ao Km ' + cidade.kmFinal + ']'
        });
      }

      cidadesData.sort((a, b) => {
        let cmp = a.value.kmInicial - b.value.kmInicial;
        if (cmp == 0) {
          cmp = ('' + a).localeCompare(b);
        }

        return cmp;
      });

      return cidadesData;
    },
    getCidadesByRodovia(rodovia) {
      const cidadesData = [];
      for (const cidade of this.cidades) {
        if (cidade.trecho.rodovia.descricao === rodovia) {
          cidadesData.push({
            value: cidade,
            text: cidade.cidade.descricao + ' - [Km ' + cidade.kmInicial + ' ao Km ' + cidade.kmFinal + ']'
          });
        }
      }

      cidadesData.sort((a, b) => {
        let cmp = a.value.kmInicial - b.value.kmInicial;
        if (cmp == 0) {
          cmp = ('' + a).localeCompare(b);
        }

        return cmp;
      });

      return cidadesData;
    },
    getGruposByObjetivos() {
      // Agrupa os Objetivos pelos Tipos (Demanda, Faixa Domínio)
      const data = [];

      const tipoDem = 'Demanda';
      const tipoFxa = 'Faixa Domínio';

      if (this.objetivos != null) {
        for (const objetivo of this.objetivos) {
          if (objetivo.value == null) continue;

          let tipoGrp = '';
          if (objetivo.value.grupo === 1) tipoGrp = tipoDem;
          else if (objetivo.value.grupo === 2) tipoGrp = tipoFxa;

          let found = false;
          for (var grpObj of data) {
            if (grpObj === tipoGrp) {
              found = true;
            }
          }

          if (!found) data.push(tipoGrp);
        }
      }
      return data;
    },
    getObjetivosByGrupo() {
      const data = [];
      const grupo = 2; // faixa domínio

      if (this.objetivos != null) {
        for (const objetivo of this.objetivos) {
          if (objetivo.value == null) continue;

          if (objetivo.value.grupo === grupo) {
            data.push(objetivo);
          }
        }
      }

      return data;
    },
    getRodoviasByTrechos() {
      const rodovias = [];
      for (const trecho of this.trechos) {
        let found = false;
        for (const rodovia of rodovias) {
          if (rodovia == trecho.rodovia.descricao) {
            found = true;
            break;
          }
        }

        if (!found) {
          rodovias.push(trecho.rodovia.descricao);
        }
      }

      return rodovias;
    },
    getTipos() {
      const data = [];
      data.push({ value: null, text: this.labelSelecionarTipo });

      for (const tipo of this.tipos) {
        if (tipo.value == null) continue;

        if (this.objetivo != undefined) {
          if (tipo.value.idObjetivo === this.objetivo) data.push(tipo);
        }
      }

      return data;
    },
    getTrechosByRodovia(rodovia) {
      const trechosData = [];

      for (const trecho of this.trechos) {
        if (trecho.rodovia == null || trecho.rodovia == undefined) {
          continue;
        }

        if (trecho.rodovia.descricao === rodovia) {
          if (this.trechoCidade != null) {
            if (this.trechoCidade == trecho.id) {
              trechosData.push(trecho);
            }
          } else {
            trechosData.push(trecho);
          }
        }
      }

      return trechosData;
    },
    getTrechoInfo(trecho) {
      if (trecho == null) {
        return null;
      }

      let trechoOutput = trecho.descricao;
      if (trecho.kmInicial != null && trecho.kmFinal != null) {
        trechoOutput +=
          ' - [KM ' +
          numeral(trecho.kmInicial).format('0.[00]') +
          ' ao KM ' +
          numeral(trecho.kmFinal).format('0.[00]') +
          ']';
      }

      return trechoOutput;
    },
    handleSelectCidade() {
      if (!this.cidade || this.cidade === null || this.cidade === undefined) {
        return;
      }

      this.trechoCidade = null;
      for (const cid of this.cidades) {
        if (cid.id === this.cidade.id) {
          this.trechoCidade = cid.idTrecho;
          break;
        }
      }

      if (this.trechoCidade != null) {
        if (this.trecho == null || this.trecho !== this.trechoCidade) {
          this.trecho = this.trechoCidade;
        }
      }

      this.coordenadasRodovia = [];
      this.coordenadasCrescente = [];
      this.coordenadasDecrescente = [];

      this.validateKmAgainstCity();
    },
    hasHiddenField(fieldName) {
      if (this.hiddenFields == undefined || this.hiddenFields == null) return true;

      let hiddenFields = false;

      for (const value of this.hiddenFields) {
        if (value == fieldName) {
          hiddenFields = true;
        }
      }

      return hiddenFields;
    },
    hideModal() {
      this.$bvModal.hide('confirm-modal');
      this.$router.push('/');
    },
    hideModalError() {
      this.$bvModal.hide('error-modal');
    },
    validateStateAnexo(sequencia) {
      if (this.anexosInvalidos.includes(sequencia)) {
        return false;
      }
      return null;
    },
    onSubmit() {
      this.errorKmInicial = null;
      this.errorKmFinal = null;

      this.validateKmAgainstCity();

      if (this.errorKmInicial || this.errorKmFinal) {
        this.$notify({
          group: 'msgsCenter',
          title: 'Erro',
          text: 'Verifique os valores de KM informados.',
          type: 'error'
        });
        return;
      }

      this.busySave = true;

      this.anexosInvalidos = [];
      let anexosObrigatoriosValidos = true;

      if (this.anexos.length > 0) {
        for (const anexo of this.anexos) {
          if (anexo.obrigatorio == 1) {
            const hasFile = this.files.some(f => f.sequencia === anexo.id.sequencia);
            if (!hasFile) {
              anexosObrigatoriosValidos = false;
              this.anexosInvalidos.push(anexo.id.sequencia);
            }
          }
        }
      }

      if (this.showPagamento && !this.aceitePagamento) {
        this.$notify({
          group: 'msgsCenter',
          title: 'Erro',
          text: 'É necessário aceitar a declaração de ciência sobre a possibilidade de cobrança.',
          type: 'error'
        });
        this.busySave = false;
        return;
      }

      if (this.abrirEmNomeOutraParte) {
        if (!this.tipoRequerente) {
          this.$notify({
            group: 'msgsCenter',
            title: 'Erro',
            text: 'Selecione o tipo de requerente (Pessoa Física ou Pessoa Jurídica).',
            type: 'error'
          });
          this.busySave = false;
          return;
        }
        if (this.tipoRequerente === 'PF') {
          if (!this.nomeRequerente || !this.cpfRequerente) {
            this.$notify({
              group: 'msgsCenter',
              title: 'Erro',
              text: 'Preencha todos os campos do requerente (Nome completo e CPF).',
              type: 'error'
            });
            this.busySave = false;
            return;
          }
        } else if (this.tipoRequerente === 'PJ') {
          if (!this.nomeRequerente || !this.cnpjRequerente) {
            this.$notify({
              group: 'msgsCenter',
              title: 'Erro',
              text: 'Preencha todos os campos do requerente (Razão Social e CNPJ).',
              type: 'error'
            });
            this.busySave = false;
            return;
          }
        }
      }

      this.$validator.validateAll().then(result => {
        if (!result || !anexosObrigatoriosValidos) {
          this.busySave = false;
          return;
        }

        const datSolicitacao = new Date();

        // Form submit logic
        const sigla = this.$store.state.empresa.empresaAtual.sigla;
        const token = this.$store.state.account.user;
        const requestOpts = {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        };

        const formData = new FormData();
        formData.append('datHorSolicitacao', moment(datSolicitacao).format('YYYY-MM-DD HH:mm:ss'));
        formData.append('titulo', this.titulo);

        if (this.tipo != undefined) formData.append('tipo', this.tipo.id);

        if (this.area != undefined) formData.append('area', this.area);

        if (this.objetivo != undefined) formData.append('objetivo', this.objetivo);

        if (this.trecho != undefined) formData.append('trecho', this.trecho);

        if (this.sentido != undefined) formData.append('sentido', this.sentido);

        if (this.cidade != undefined) formData.append('cidade', this.cidade.idCidade);

        if (this.kmInicial != undefined && this.kmInicial !== '' && this.kmInicial != null) {
          const kmInicialNum = this.normalizeKm(this.kmInicial);
          if (kmInicialNum !== null && !isNaN(kmInicialNum) && isFinite(kmInicialNum)) {
            const kmInicialFormatado = kmInicialNum.toFixed(3);
            formData.append('kmInicial', kmInicialFormatado);
          }
        }

        if (this.kmFinal != undefined && this.kmFinal !== '' && this.kmFinal != null) {
          const kmFinalNum = this.normalizeKm(this.kmFinal);
          if (kmFinalNum !== null && !isNaN(kmFinalNum) && isFinite(kmFinalNum)) {
            const kmFinalFormatado = kmFinalNum.toFixed(3);
            formData.append('kmFinal', kmFinalFormatado);
          }
        }

        if (this.local != undefined) formData.append('local', this.local);

        if (this.alca != undefined) formData.append('alca', this.alca);

        if (this.faixa != undefined) formData.append('faixa', this.faixa);

        if (this.observacao != undefined && this.observacao.trim() !== '')
          formData.append('observacoes', this.observacao);

        if (this.abrirEmNomeOutraParte) {
          formData.append('abrirEmNomeOutraParte', true);
          if (this.tipoRequerente === 'PF') {
            formData.append('tipoRequerente', 'PF');
            formData.append('nomeRequerente', this.nomeRequerente);
            formData.append('cpfRequerente', this.cpfRequerente.replace(/\D/g, ''));
          } else if (this.tipoRequerente === 'PJ') {
            formData.append('tipoRequerente', 'PJ');
            formData.append('razaoSocialRequerente', this.nomeRequerente);
            formData.append('cnpjRequerente', this.cnpjRequerente.replace(/\D/g, ''));
          }
        }
        if (this.showPagamento) {
          formData.append('aceitePagamento', this.aceitePagamento);
        }

        formData.append('grupo', 2);

        for (var i = 0; i < this.files.length; i++) {
          formData.append('files', this.files[i]);
        }

        for (var x = 0; x < this.tiposAnexo.length; x++) {
          formData.append('tiposArquivos', this.tiposAnexo[x]);
        }

        Vue.axios
          .post(`/faixasDominio/${sigla}`, formData, requestOpts)
          .then(response => {
            this.protocolo = response.data.nroProtocolo;
            // Armazena o ID da demanda para gerar o PDF posteriormente
            if (response.data.id && response.data.id.idDemanda) {
              this.demandaIdCriada = response.data.id.idDemanda;
            }

            if (this.protocolo == null || this.protocolo == undefined) {
              this.$bvModal.show('error-modal');
            } else {
              this.$bvModal.show('confirm-modal');

              this.$notify({
                group: 'msgs',
                title: 'Confirmação',
                text: 'Solicitação incluída com sucesso.'
              });

              this.busySave = false;
            }
          })
          .catch(error => {
            const errorMsg = error.response ? error.response.data.message : error;

            if (errorMsg.toLowerCase().indexOf('km inicial') != -1) {
              this.errorKmInicial = 'Trecho: Erro Km Inicial';
              this.errorKmFinal = 'Trecho: Erro Km Final';
            }

            this.$notify({
              group: 'msgsCenter',
              title: 'Erro',
              text: errorMsg,
              type: 'error'
            });

            this.busySave = false;
          });
      });
    },
    onUploadAnexos(file, sequencia) {
      if (file != undefined) {
        const fileIndex = this.files.findIndex(f => f.sequencia === sequencia);
        if (fileIndex > -1) {
          this.files.splice(fileIndex, 1);
        }

        const tipoIndex = this.tiposAnexo.indexOf(sequencia);
        if (tipoIndex > -1) {
          this.tiposAnexo.splice(tipoIndex, 1);
        }

        file.sequencia = sequencia;
        this.files.push(file);
        this.tiposAnexo.push(sequencia);

        const invalidIndex = this.anexosInvalidos.indexOf(sequencia);
        if (invalidIndex > -1) {
          this.anexosInvalidos.splice(invalidIndex, 1);
        }
      }
    },
    removeAnexo(anexoItem) {
      const sequencia = anexoItem.id.sequencia;

      const fileIndex = this.files.findIndex(f => f.sequencia === sequencia);
      if (fileIndex > -1) {
        this.files.splice(fileIndex, 1);
      }

      const tipoIndex = this.tiposAnexo.indexOf(sequencia);
      if (tipoIndex > -1) {
        this.tiposAnexo.splice(tipoIndex, 1);
      }

      anexoItem.uploadedFile = null;

      if (anexoItem.obrigatorio == 1) {
        if (!this.anexosInvalidos.includes(sequencia)) {
          this.anexosInvalidos.push(sequencia);
        }
      }
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    getImagemBackgound() {
      this.backgroundTopoEmpresa = "background-image: url('img/" + this.empresaAtual.sigla + "/solicitacao.jpg')";
    },
    handleChangeObjetivo() {
      this.showAlertPagamento();
      this.getModelosObjetivo();
    },
    getModelosObjetivo() {
      this.modelosObjetivo = [];

      if (this.objetivo == null) return;

      const token = this.$store.state.account.user;
      const options = { headers: { Authorization: `Bearer ${token}` } };

      Vue.axios
        .get(`/demandas/${this.empresaAtual.sigla}/objetivos/${this.objetivo}/modelos`, options)
        .then(response => {
          this.modelosObjetivo = response.data || [];
        })
        .catch(() => {
          this.modelosObjetivo = [];
        });
    },
    downloadModelo(modelo) {
      this.executeDownloadAnexo(modelo);
    },
    getTiposArquivos() {
      const token = this.$store.state.account.user;
      const options = { headers: { Authorization: `Bearer ${token}` } };

      this.anexos = [];
      this.anexosInvalidos = [];

      if (this.tipo !== null) {
        Vue.axios.get(`/demandas/${this.empresaAtual.sigla}/tipos/${this.tipo.id}`, options).then(response => {
          const arquivos = response.data.arquivos;
          if (arquivos.length > 0) {
            for (const arquivo of arquivos) {
              this.anexos.push(arquivo);
            }
          }
        });
      }
    },

    hasArquivo(tipoAtivo) {
      if (this.anexos == null || this.anexos.length === 0) return false;

      for (const anexo of this.anexos) if (anexo.tipoAtivo === tipoAtivo) return true;

      return false;
    },
    getTipoArquivo(item) {
      let text = '';

      for (const arquivo of this.optionsArquivo) {
        if (arquivo.id === item.tipoArquivo) {
          text = arquivo.descricao;
        }
      }

      return text;
    },
    getDownloadAnexoTipo() {
      const token = this.$store.state.account.user;

      if (this.tipo.idAnexo != undefined) {
        const options = { headers: { Authorization: `Bearer ${token}` } };
        Vue.axios
          .get(`/ged/${this.empresaAtual.sigla}/${this.tipo.idAnexo}`, options)
          .then(response => {
            console.log('getDownloadAnexoTipo() => ', response.data);
            let arquivo = response.data;

            if (arquivo.uuid !== undefined) {
              this.executeDownloadAnexo(arquivo);
            }
          })
          .catch(error => {
            this.showErrorNotify('Erro', error.data ? error.data : error);
          });
      }
    },

    executeDownloadAnexo(anexo) {
      const token = this.$store.state.account.user;
      const siglaEmpresa = this.empresaAtual.sigla;
      const modulo = 'DEM';

      const requestCfg = {
        method: 'GET',
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      };

      Vue.axios
        .get(`/downloads/${siglaEmpresa}/anexos/${modulo}/${anexo.uuid}`, requestCfg)
        .then(response => {
          console.log('executeDownloadAnexo...');
          this.downloadFile(new Blob([response.data]), anexo.nome);
        })
        .catch(error => {
          this.showErrorNotify('Erro', error.data ? error.data : error);
        });
    },

    getTypeFile(typeFile) {
      let type = '';

      if (typeFile === 1) {
        // Arquivo PDF
        type = '.pdf';
      } else if (typeFile === 2) {
        // Documento de Texto (DOCX)
        type = '.doc, .docx';
      } else if (typeFile === 3) {
        // Planilha Eletrônica (XLSX)
        type = '.xlsx, .xlsm, .xls, .csv';
      } else if (typeFile === 4) {
        // Imagem (PNG/JPG/BMP)
        type = 'image/*';
      } else if (typeFile === 5) {
        // PowerPoint (PPT)
        type = '.pptx, .ppt';
      } else if (typeFile === 6) {
        // E-mail (MSG/EML)
        type = '.eml, .msg';
      } else if (typeFile === 7) {
        // Arquivo Compactado (ZIP/RAR)
        type = '.bzip2, .gzip, .tar, .wim, .7z';
      } else if (typeFile === 8) {
        // Projeto CAD (DWG/DXF)
        type = '.dwg, .dxf';
      } else if (typeFile === 9) {
        // Arquivo KMZ
        type = '.kml, .kmz, .csv, .tsv, .gpx, .xlsx';
      }

      return type;
    },

    downloadFile(blob, fileName) {
      const link = document.createElement('a');
      // create a blobURI pointing to our Blob
      link.href = URL.createObjectURL(blob);
      console.log('fileName==>', fileName);
      if (fileName) link.download = fileName;
      link.target = '_blank';
      // some browser needs the anchor to be in the doc
      document.body.appendChild(link);
      link.click();
      link.remove();
      // in case the Blob uses a lot of memory
      setTimeout(() => URL.revokeObjectURL(link.href), 6000);
    },

    openMapForChooseKm(km) {
      this.chooseKm = km;
      this.showCoordenadasAlert = false; // Reset do alerta
      this.showSentidoUnicoAlert = false; // Reset do alerta de sentido único

      if (km == 'I') {
        this.loadingCoordRodKmInicial = true;
      } else {
        this.loadingCoordRodKmFinal = true;
      }

      this.coordenadasRodovia = [];
      this.coordenadasCrescente = [];
      this.coordenadasDecrescente = [];
      const newPosition = {};
      let trechoAux = {};
      let cidadeAux = {};

      if (this.cidade === null || this.cidade === undefined) {
        this.showCoordenadasAlert = true;
        this.$bvModal.show('modalChooseKm');
        if (km == 'I') {
          this.loadingCoordRodKmInicial = false;
        } else {
          this.loadingCoordRodKmFinal = false;
        }
        return;
      }

      for (const cid of this.cidades) {
        if (cid.id === this.cidade.id) {
          cidadeAux = cid;
          break;
        }
      }

      if (this.trecho !== undefined) {
        for (const trecho of this.trechos) {
          if (trecho.id == this.trecho) {
            trechoAux = trecho;
            break;
          }
        }
      }

      const token = this.$store.state.account.user;
      const options = { headers: { Authorization: `Bearer ${token}` } };

      const kmInicialCidade = cidadeAux.kmInicial;
      const kmFinalCidade = cidadeAux.kmFinal;

      Vue.axios
        .get(
          `/rodovias/${this.empresaAtual.sigla}/${
            trechoAux.rodovia.descricao
          }/coordenadas?kmInicial=${kmInicialCidade}&kmFinal=${kmFinalCidade}`,
          options
        )
        .then(response => {
          if (!response.data || response.data.length === 0) {
            this.showCoordenadasAlert = true;
          }

          const normalizeNumber = v => {
            if (v === null || v === undefined) return 0;
            const n = parseFloat(String(v).replace(',', '.'));
            return isNaN(n) ? 0 : n;
          };
          const toKm = v => (v > 1000 ? v / 1000 : v);

          const cityIni = normalizeNumber(kmInicialCidade);
          const cityFim = normalizeNumber(kmFinalCidade);
          const minKmCidade = Math.min(cityIni, cityFim);
          const maxKmCidade = Math.max(cityIni, cityFim);

          for (const coord of response.data) {
            const coordData = {
              lat: coord.latitude,
              lng: coord.longitude,
              km: toKm(normalizeNumber(coord.kilometro)),
              sentido: coord.sentido
            };

            this.coordenadasRodovia.push(coordData);
          }

          this.coordenadasRodovia = this.coordenadasRodovia.filter(c => c.km >= minKmCidade && c.km <= maxKmCidade);

          this.coordenadasRodovia.sort((a, b) => a.km - b.km);

          for (const coordData of this.coordenadasRodovia) {
            const sentidoCoord = String(coordData.sentido || '').toUpperCase();
            if (sentidoCoord === 'CRESCENTE' || sentidoCoord === 'C' || sentidoCoord === '1') {
              this.coordenadasCrescente.push(coordData);
            } else if (sentidoCoord === 'DECRESCENTE' || sentidoCoord === 'D' || sentidoCoord === '2') {
              this.coordenadasDecrescente.push(coordData);
            } else {
              const coordCrescente = {
                ...coordData,
                lat: coordData.lat + 0.00005, // Deslocamento de ~5 metros (mais próximo)
                lng: coordData.lng + 0.00005
              };

              const coordDecrescente = {
                ...coordData,
                lat: coordData.lat - 0.00005, // Deslocamento de ~5 metros (mais próximo)
                lng: coordData.lng - 0.00005
              };

              this.coordenadasCrescente.push(coordCrescente);
              this.coordenadasDecrescente.push(coordDecrescente);
            }
          }

          if (this.coordenadasCrescente.length === 0 && this.coordenadasDecrescente.length === 0) {
            for (const coord of this.coordenadasRodovia) {
              const coordCrescente = {
                ...coord,
                lat: coord.lat + 0.00005,
                lng: coord.lng + 0.00005
              };

              const coordDecrescente = {
                ...coord,
                lat: coord.lat - 0.00005,
                lng: coord.lng - 0.00005
              };

              this.coordenadasCrescente.push(coordCrescente);
              this.coordenadasDecrescente.push(coordDecrescente);
            }
          }

          const temCrescente = this.coordenadasCrescente.length > 0;
          const temDecrescente = this.coordenadasDecrescente.length > 0;

          if ((temCrescente && !temDecrescente) || (!temCrescente && temDecrescente)) {
            this.showSentidoUnicoAlert = true;
            this.sentidoDisponivel = temCrescente ? 'CRESCENTE' : 'DECRESCENTE';
          }

          this.$forceUpdate();

          if (this.coordenadasRodovia.length === 0) {
            this.showCoordenadasAlert = true;
            newPosition.lat = -23.550278;
            newPosition.lng = -46.633889;
          } else {
            for (const coord of this.coordenadasRodovia) {
              newPosition.lat = parseFloat(coord.lat);
              newPosition.lng = parseFloat(coord.lng);
              break;
            }
          }

          this.mapOptions.center = newPosition;
          this.$bvModal.show('modalChooseKm');

          if (km == 'I') {
            this.loadingCoordRodKmInicial = false;
          } else {
            this.loadingCoordRodKmFinal = false;
          }
        })
        .catch(error => {
          console.error('Erro ao carregar coordenadas:', error);
          this.showCoordenadasAlert = true;

          // Define posição padrão em caso de erro
          newPosition.lat = -23.550278;
          newPosition.lng = -46.633889;
          this.mapOptions.center = newPosition;

          // Ainda mostra o modal mesmo com erro
          this.$bvModal.show('modalChooseKm');

          if (km == 'I') {
            this.loadingCoordRodKmInicial = false;
          } else {
            this.loadingCoordRodKmFinal = false;
          }
        });
    },

    haversineDistance(lat1, lon1, lat2, lon2) {
      const R = 6371; // Raio médio da Terra em quilômetros
      const dLat = this.toRadians(lat2 - lat1);
      const dLon = this.toRadians(lon2 - lon1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(this.toRadians(lat1)) * Math.cos(this.toRadians(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    },

    toRadians(degrees) {
      return degrees * (Math.PI / 180);
    },

    ChooseKmMap(event) {
      const coordEvent = {
        lat: parseFloat(event.latLng.lat().toFixed(6)),
        lng: parseFloat(event.latLng.lng().toFixed(6))
      };

      let coordenadasParaUsar = this.coordenadasRodovia;

      if (this.sentido !== null && this.sentido !== undefined) {
        if (this.sentido === 'CRESCENTE' || this.sentido === 'C' || this.sentido === '1' || this.sentido === 1) {
          coordenadasParaUsar =
            this.coordenadasCrescente.length > 0 ? this.coordenadasCrescente : this.coordenadasRodovia;
        } else if (
          this.sentido === 'DECRESCENTE' ||
          this.sentido === 'D' ||
          this.sentido === '2' ||
          this.sentido === 2
        ) {
          coordenadasParaUsar =
            this.coordenadasDecrescente.length > 0 ? this.coordenadasDecrescente : this.coordenadasRodovia;
        } else if (this.sentido === 'AMBOS' || this.sentido === 'A' || this.sentido === 0) {
          coordenadasParaUsar = this.coordenadasRodovia;
        }
      }

      let findKm = null;
      let menorDistancia = Infinity;

      for (const coord of coordenadasParaUsar) {
        const distancia = this.haversineDistance(coordEvent.lat, coordEvent.lng, coord.lat, coord.lng);
        if (distancia < menorDistancia) {
          menorDistancia = distancia;
          findKm = coord;
        }
      }

      if (findKm !== undefined) {
        const kmFormatado = this.normalizeKm(findKm.km);

        if (this.chooseKm == 'I') {
          this.kmInicial = kmFormatado;
        } else if (this.chooseKm == 'F') {
          this.kmFinal = kmFormatado;
        }

        this.$bvModal.hide('modalChooseKm');
      }
    },
    showAlertPagamento() {
      if (this.objetivo !== undefined) {
        for (const obj of this.objetivos) {
          if (obj.value !== null && obj.value.id === this.objetivo) {
            if (obj.value.pagamento === 'S') {
              this.showPagamento = true;
            } else {
              this.showPagamento = false;
            }
            // exibir descrição detalhada igual do pagamento
            if (obj.value.descricaoDetalhada?.trim()) {
              this.descricaoMensagem = obj.value.descricaoDetalhada.trim();
              this.showDescricao = true;
            } else {
              this.showDescricao = false;
            }
          }
        }
        this.anexos = [];
        this.anexosInvalidos = [];
      }
    },
    getRefCodeDemandas() {
      const token = this.$store.state.account.user;
      const options = { headers: { Authorization: `Bearer ${token}` } };

      const sigla = this.$store.state.empresa.empresaAtual.sigla;
      const refName = 'DEMANDA.PAGAMENTO_LINK';

      Vue.axios
        .get(`/core/refCodes/${sigla}?search=${refName}`, options)
        .then(response => {
          if (response.data.length != 0) {
            this.refCodeDemandas = response.data[0];
            if (!this.linkValoresUrl && this.refCodeDemandas.value) {
              this.linkValoresUrl = this.refCodeDemandas.value;
            }
          }
        })
        .catch(error => {
          this.$notify({
            group: 'msgs',
            title: 'Catch',
            text: error,
            type: 'error'
          });
        });
    },
    formatarCPF(event) {
      if (!event) return;
      const valorInput = event.target && event.target.value !== undefined ? event.target.value : (typeof event === 'string' ? event : this.cpfRequerente || '');
      let valor = String(valorInput).replace(/\D/g, '');
      if (valor.length <= 11) {
        valor = valor.replace(/(\d{3})(\d)/, '$1.$2');
        valor = valor.replace(/(\d{3})(\d)/, '$1.$2');
        valor = valor.replace(/(\d{3})(\d{1,2})$/, '$1-$2');
        if (valor !== this.cpfRequerente) {
          this.cpfRequerente = valor;
        }
      }
    },
    formatarCNPJ(event) {
      if (!event) return;
      const valorInput = event.target && event.target.value !== undefined ? event.target.value : (typeof event === 'string' ? event : this.cnpjRequerente || '');
      let valor = String(valorInput).replace(/\D/g, '');
      if (valor.length <= 14) {
        valor = valor.replace(/^(\d{2})(\d)/, '$1.$2');
        valor = valor.replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3');
        valor = valor.replace(/\.(\d{3})(\d)/, '.$1/$2');
        valor = valor.replace(/(\d{4})(\d)/, '$1-$2');
        if (valor !== this.cnpjRequerente) {
          this.cnpjRequerente = valor;
        }
      }
    },
    gerarReciboPDF() {
      const token = this.$store.state.account.user;
      const sigla = this.$store.state.empresa.empresaAtual.sigla;
      
      const downloadPDF = (idDemanda) => {
        const url = `/faixasDominio/relatorios/${sigla}/${idDemanda}/recibo-protocolo`;
        const requestCfg = {
          headers: { Authorization: `Bearer ${token}` },
          responseType: 'blob'
        };
        
        Vue.axios.get(url, requestCfg)
          .then(response => {
            const fileName = `recibo-protocolo-${this.protocolo || idDemanda}.pdf`;
            this.downloadFile(new Blob([response.data]), fileName);
          })
          .catch(() => {
            this.$notify({
              group: 'msgsCenter',
              title: 'Erro',
              text: 'Erro ao gerar recibo em PDF.',
              type: 'error'
            });
          });
      };
      
      if (this.demandaIdCriada) {
        downloadPDF(this.demandaIdCriada);
      } else {
        Vue.axios.get(`/faixasDominio/${sigla}`, {
          headers: { Authorization: `Bearer ${token}` },
          params: { titulo: '', status: 0 }
        }).then(response => {
          const demandas = response.data.demandas || [];
          const demanda = demandas.find(d => d.nroProtocolo === this.protocolo);
          
          if (demanda && demanda.id && demanda.id.idDemanda) {
            downloadPDF(demanda.id.idDemanda);
          } else {
            this.$notify({
              group: 'msgsCenter',
              title: 'Erro',
              text: 'Não foi possível localizar a demanda para gerar o recibo.',
              type: 'error'
            });
          }
        }).catch(error => {
          this.$notify({
            group: 'msgsCenter',
            title: 'Erro',
            text: 'Erro ao gerar recibo: ' + (error.response?.data?.message || error.message),
            type: 'error'
          });
        });
      }
    }
  }
};
</script>
<style>
/* Ajuste e estilo para campos de anexos: */
.anexo-centralizado {
  min-height: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.nome-arquivo-centralizado {
  display: flex;
  align-items: center;
  font-size: 1em;
  margin: 0;
  height: 100%;
}

.arquivo-borda {
  border: 1.5px solid #ced4da;
  border-radius: 0.25rem;
  padding: 2px 8px 2px 12px;
  background: #fff;
  font-size: 1em;
  min-width: 120px;
  text-align: center;
  display: flex;
  align-items: center;
  height: 28px;
  gap: 4px;
}

.btn-excluir-arquivo {
  border: none;
  background: #e9ecef;
  border-radius: 0.25rem;
  height: 28px;
  width: 38px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  margin-left: auto;
}

.btn-excluir-arquivo:hover {
  background: #dee2e6;
}

.icone-lixeira-vermelha {
  color: #dc3545 !important;
}

.b-table tbody td {
  vertical-align: middle !important;
}

table {
  font-size: 0.8571em;
}

/* Ajuste e estilo para botões de setas e ícones de validação dos campos de Objetivo, Tipo, e outros determinados campos */
.form-control.custom-select-green {
  background-size: 0.75rem 0.75rem;
}
.form-control.custom-select-green.is-valid {
  border-color: #28a745;
  padding-right: calc(2.5em + 0.75rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%2328a745' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e"),
    url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e");
  background-repeat: no-repeat, no-repeat;
  background-position: right calc(1.75em + 0.5rem) center, right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem), 0.75rem 0.75rem;
}

.form-control.custom-select-green.is-invalid {
  border-color: #dc3545;
  padding-right: calc(2.5em + 0.75rem);
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e"),
    url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e");
  background-repeat: no-repeat, no-repeat;
  background-position: right calc(1.75em + 0.5rem) center, right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem), 0.75rem 0.75rem;
}
</style>
